export default {
  // モジュールヘッダー
  header: {
    title: '旅行',
    subtitle: 'スマートな旅程提案、AIレシート認識',
  },

  common: {
    close: '閉じる',
  },

  // トラベルカード
  travelCard: {
    status: {
      active: 'アクティブ',
      planning: '計画中',
      completed: '完了',
      cancelled: 'キャンセル済み',
    },
    actions: {
      viewDetails: '詳細を表示',
      joinTravel: '旅行に参加',
      editTravel: '旅行を編集',
      enterChat: 'チャットに入る',
    },
    info: {
      members: 'メンバー',
      budget: '予算',
      duration: '期間',
      days: '日間',
      perPerson: '/ 人',
      noLocation: '場所が設定されていません',
      noBudget: '予算が設定されていません',
      noMembers: 'メンバーがまだいません',
      memberCount: '{{count}} メンバー',
      memberCount_plural: '{{count}} メンバー',
      actualCost: '実際の費用',
      public: '公開',
      friendsOnly: '友達のみ',
      private: 'プライベート',
    },
    dates: {
      to: '～',
      startDate: '出発日',
      endDate: '帰着日',
    },
  },

  // トラベルリスト
  travelList: {
    loading: {
      title: '旅行リストを読み込み中...',
      subtitle: 'しばらくお待ちください',
    },
    empty: {
      title: 'まだプロジェクトがありません',
      subtitle: '右上のボタンをクリックして最初のプロジェクトを作成してください',
    },
    messages: {
      error: 'エラー',
      fetchListFailed: 'プロジェクトリストの取得に失敗しました',
      unknownError: '不明なエラー',
      likeFailed: 'いいね操作に失敗しました',
    },
  },

  // 旅行作成
  createTravel: {
    // ページヘッダー
    header: {
      title: '旅行を作成',
      subtitle: 'プロジェクト情報を入力してください',
    },
    title: '旅行を作成',
    // 基本情報
    projectName: 'プロジェクト名',
    projectNamePlaceholder: '旅行に名前を付けてください',
    dateRange: '旅行日程',
    startDate: '出発日',
    endDate: '帰着日',
    // 目的地
    destination: '目的地',
    selectCountry: '国を選択',
    selectCity: '都市を選択',
    customCity: 'またはカスタム都市を入力',
    customCityPlaceholder: '都市名を入力（例：パリ、東京、ニューヨーク）',
    destinationLabel: '目的地：',
    // 旅行の好み
    travelPreferences: '旅行の好み',
    preferencesSubtitle: '興味のあるものを選択して、AIが旅程をカスタマイズします',
    multiSelect: '（複数選択可）',
    // 好みのオプション
    preferences: {
      culture: '文化',
      food: 'グルメ',
      scenery: '風景',
      history: '歴史',
      deepTour: 'ディープツアー',
      checkin: 'チェックイン',
    },
  // プロジェクトの説明
  projectDescription: 'プロジェクトの説明',
  editItinerary: '行程を編集',
    descriptionPlaceholder: 'この旅行の特徴やハイライトを紹介...',
    aiGenerate: 'AIで説明を生成',
    aiGenerating: '生成中...',
    // 支払いモード
    paymentMode: '支払いモード',
    prepayAverage: '事前均等払い',
    prepayAverageDesc: '事前に固定額を徴収、均等に分配',
    prepayShare: '事前シェア払い',
    prepayShareDesc: '事前に固定額を徴収、シェアに基づいて分配',
    actualAverage: '実費（均等）',
    actualAverageDesc: '実際の費用を後で均等に分配',
    actualShare: '実費（シェア）',
    actualShareDesc: '実際の費用を後でシェアに基づいて分配',
    // 決済通貨
    settlementCurrency: '決済通貨',
    selectCurrency: '通貨を選択',
    // 通貨名
    currencies: {
      CNY: '中国元',
      USD: '米ドル',
      EUR: 'ユーロ',
      JPY: '日本円',
      GBP: '英国ポンド',
      AUD: '豪ドル',
      CAD: 'カナダドル',
      CHF: 'スイスフラン',
      HKD: '香港ドル',
      SGD: 'シンガポールドル',
      KRW: '韓国ウォン',
      TWD: '台湾ドル',
      THB: 'タイバーツ',
      MYR: 'マレーシアリンギット',
    },
    // 1人当たり予算
    budgetPerPerson: '1人当たり予算',
    budgetPlaceholder: '0',
    budgetUnit: '/ 人',
    budgetHint: '予算計画とメンバーの参考のための1人当たり推定費用',
    // プロジェクトの公開設定
    projectVisibility: 'プロジェクトの公開設定',
    visibilitySubtitle: '旅行プロジェクトを見たり参加できる人を選択',
    friendsVisible: '友達に公開',
    friendsVisibleDesc: '友達が見たり参加申請できます',
    privateProject: 'プライベートプロジェクト',
    privateProjectDesc: '友だけ誘う',
    // 背景画像
    backgroundImage: '背景画像',
    selectBackground: '背景を選択',
  backgroundPlaceholder: 'クリックして背景画像を選択',
  selectBackgroundPlaceholder: 'クリックして背景画像を選択',
    backgroundImages: {
      beach: 'ビーチバケーション',
      churches: '教会建築',
      airplane: 'フライトの旅',
      cruise: 'クルーズ旅行',
      fuji: '富士山',
      germany: 'ドイツの風景',
      holland: 'オランダの風車',
      hongkong: '香港の夜景',
      korea: '韓国の風景',
      london: 'ロンドンの印象',
      maldives: 'モルディブ',
      mountain: '山の雪景色',
      paris: 'パリのロマンス',
      sakura: '桜',
      sea: '青い海',
      shanghai: '上海の風景',
      singapore: 'シンガポールの印象',
      snow: '降雪',
      sunrise: '日の出',
      sunsets: '日没',
      swiss: 'スイスの風景',
      thailand: 'タイの風情',
      vietnam: 'ベトナムの印象',
      waterfalls: '滝の風景',
    },
    // ボタン
    createProject: '旅行プロジェクトを作成',
    next: '旅行を作成',
    // アラートメッセージ
    alerts: {
      hint: 'ヒント',
      success: '成功',
      error: 'エラー',
      enterProjectName: 'プロジェクト名を入力してください',
      selectDestination: '目的地を選択してください',
      selectDestinationCity: '目的地の都市を選択してください',
      enterProjectDescription: 'プロジェクトの説明を入力してください',
      invalidDateRange: '終了日は開始日より前に設定できません',
      generatedSuccess: 'AIによる説明の生成に成功しました！',
      generateFailed: 'AI生成に失敗しました',
      aiGenerationFailed: 'AI生成に失敗しました',
      errorDetails: 'エラーの詳細',
      createSuccess: '旅行プロジェクトが正常に作成されました！',
      createSuccessMessage: '旅行プロジェクトが作成されました。友達を招待してください！',
      createFailed: '作成に失敗しました',
      createFailedMessage: 'ネットワーク接続を確認して、もう一度お試しください',
      createFailedDetail: '問題が解決しない場合は、カスタマーサービスにご連絡ください。',
      userNotLoggedIn: 'ユーザーがログインしていません、まずログインしてください',
      unknownError: '不明なエラー',
      travelCreateFailed: '旅行作成に失敗しました',
      viewProject: 'プロジェクトを表示',
      // AI関連のアラート
      aiDisabledMessage: 'AIスマート推奨機能が無効です\nAI旅程生成がキャンセルされました\n設定で再度有効にできます',
      goToSettings: '設定に移動',
    },
    // AIプロンプト関連
    aiPrompt: {
      role: 'あなたはプロの旅行プランナーです。以下の旅行プロジェクトに対して、詳細で魅力的かつ実際的な旅程紹介を生成してください。',
      // 基本情報セクション
      basicInfo: 'プロジェクト基本情報',
      projectNameLabel: 'プロジェクト名',
      destinationLabel: '目的地',
      travelTimeLabel: '旅行期間',
      participantsLabel: '参加者',
      preferencesLabel: '旅行の好み',
      budgetLabel: '1人当たり予算',
      noPreferences: '特定の好みなし',
      budgetTbd: '予算未定',
      paymentModeLabel: '支払いモード',
      daysCount: '（合計{days}日間）',
      // 支払いモードのマッピング
      paymentModes: {
        prepay_average: '事前均等払いモード',
        prepay_share: '事前シェア払いモード',
        actual_average: '実費均等モード',
        actual_share: '実費シェアモード',
      },
      // 要件セクション
      requirements: '生成要件',
      generateContent: '以下の内容を含む旅程紹介を生成してください：',
      contentItems: {
        highlights: '**プロジェクトのハイライト**：目的地の特徴とユーザーの好みに基づいて、この旅行のユニークな点を強調',
        itinerary: '**詳細な旅程**：日ごとの具体的な観光地、アクティビティ、体験を計画',
        food: '**グルメ推奨**：地元の名物料理やレストラン推奨',
        accommodation: '**宿泊提案**：チームに適した宿泊タイプとエリア',
        transportation: '**交通ガイド**：目的地へのアクセス方法と現地の交通手段',
        budget: '**予算参考**：各種費用の大まかな予算範囲',
        tips: '**実践的なヒント**：天気、ビザ、必需品、その他の実践的な情報',
        teamActivities: '**チームアクティビティ**：{min}～{max}人チームに適した特別なアクティビティ',
      },
      // スタイル要件セクション
      styleRequirements: 'スタイル要件',
      styleItems: {
        0: '生き生きとした魅力的な言葉遣い',
        1: '詳細かつ具体的な内容で実際的',
        2: 'チームワークと社交的属性を強調',
        3: 'グループ旅行の経済的利点と楽しさを反映',
        4: '適切な絵文字を使用して興味を追加',
        5: '総文字数を400～500語以内に抑える',
      },
      generateStart: '生成を開始してください：',
    },
  },

  // 旅行詳細ページ
  travelDetail: {
    loading: {
      title: '旅行詳細を読み込み中...',
      subtitle: 'しばらくお待ちください',
    },
    error: {
      title: '読み込みに失敗しました',
      subtitle: '旅行プロジェクトが見つかりません',
      retryButton: '再読み込み',
    },
    actions: {
      editItinerary: '行程を編集',
      approve: '承認',
      reject: '拒否',
      settlement: '支払い設定',
    },
    // ページコンテンツ
    content: {
      projectDescription: 'プロジェクトの説明',
      todoList: 'ToDoリスト',
      members: '旅行メンバー',
      add: '追加',
      expand: '展開',
      collapse: '折りたたむ',
      expandWithCount: '展開（{{count}}項目）',
      unknownUser: '不明なユーザー',
      creator: '作成者',
      member: 'メンバー',
      completed: '完了',
      inviteFriends: '友だけ誘う',
      recommendFriends: '友達を推薦',
      noTodos: 'ToDoがまだありません',
      noTodosSubtext: '右上の追加ボタンをクリックしてToDoを作成してください',
    },
    // モーダル
    modal: {
      paymentSettings: '支払い設定',
      paymentMode: '支払いモード',
      memberShareSettings: 'メンバーシェア設定',
      memberShareDescription: '各メンバーのシェア比率を設定。例：大人1.0、子供0.5、カップル2.0',
      totalShares: '総シェア数',
      averageMode: '均等モード',
      shareMode: 'シェアモード',
      prepaidMode: '事前払いモード（旅行代理店モード、返金不可）',
      actualExpenseMode: '実費モード（実際の費用で分配）',
      currentProjectUses: '現在のプロジェクト使用状況',
    },
    // メッセージ
    messages: {
      success: '成功',
      error: 'エラー',
      loadFailed: '旅行詳細の読み込みに失敗しました',
      unknownError: '不明なエラー',
      userNotLoggedIn: 'ユーザーがログインしていません',
      paymentSettingsSaved: '支払い設定が保存されました',
      saveShareSettingsFailed: 'シェア設定の保存に失敗しました',
      addTodoFailed: 'ToDoの追加に失敗しました',
      batchAddTodosFailed: 'ToDoの一括追加に失敗しました',
      todosAdded: '{{count}}件のToDoを追加しました',
      operationFailed: '操作に失敗しました',
      likeFailed: 'いいね操作に失敗しました',
      insufficientPermission: '権限が不足しています',
      needJoinFirst: '友達を推薦する前にプロジェクトに参加する必要があります',
      onlyCreatorCanInvite: 'プライベートプロジェクトでは作成者のみが友達を招待できます',
      savePaymentModeFailed: '支払いモードの保存に失敗しました',
    },
  },

  // 費用設定モーダル
  expenseSettingsModal: {
    // ヘッダー
    title: '費用共有設定',
    cancel: 'キャンセル',
    save: '保存',
    // 権限通知
    permissionNotice: '旅行作成者のみが費用設定を変更できます',
    // 費用モード
    expenseModeSection: {
      title: '📊 共有モード',
      subtitle: '旅行活動に適した費用管理方法を選択してください',
      // 事前払いモード
      prepaidMode: {
        title: '事前払いモード',
        subtitle: 'メンバーが事前に支払い、統一的に費用管理',
        description: '観光や集まりなど、予算が明確な旅行活動に適しています。総予算の設定が必要です。',
        features: [
          '総予算額を設定',
          'メンバーがシェア比率で事前支払い',
          'リアルタイムでの残高追跡',
          '返金または追加支払いの清算',
        ],
      },
      // 実費モード
      actualExpenseMode: {
        title: '実費モード',
        subtitle: 'メンバーが各自で支払い、後で実際の費用を分配',
        description: 'プロジェクト協力など、費用が不確定な旅行活動に適しています。予算設定は不要です。',
        features: [
          'レシートのアップロード',
          '費用承認プロセス',
          '柔軟なカテゴリー管理',
          '実際の費用の分配',
        ],
      },
    },
    // シェア設定
    shareSection: {
      title: '⚖️ シェア比率',
      subtitle: '具体的な費用共有方法を選択してください',
      toggleTitle: 'シェアベースの分割を有効化',
      // 異なるモードの説明
      descriptions: {
        prepaidWithShares: '事前支払い後に実際の消費に基づいて返金または追加支払い、個人差を考慮',
        prepaidWithoutShares: '旅行グループモードのように、作成者がすべて手配、均等に分配',
        actualExpenseWithShares: '実際の費用をメンバーシェア比率で分配',
        actualExpenseWithoutShares: 'すべての費用を均等に分配、個人差を考慮しない',
      },
      // シェア分割の例
      shareExamples: {
        title: '💡 シェア分割の説明',
        prepaidMode: '事前払いモード + シェア分割：\n• メンバーがシェア比率で異なる金額を事前支払い\n• 活動後に実際の消費に基づいて再計算\n• 個人差を反映して返金または追加支払い\n• 適している：家族旅行、友達の集まり',
        actualExpenseMode: '実費 + シェア分割：\n• メンバーが個別に支払い、レシートをアップロード\n• 総費用をシェア比率で分配\n• 最終的に差額を統一清算\n• 適している：プロジェクト協力、AA制の集まり',
      },
      // 均等分割の例
      averageExamples: {
        title: '📋 均等分割の説明',
        prepaidMode: '事前払いモード + 均等分割：\n• 全員が同じ金額を事前支払い\n• 作成者がすべての活動を統一手配\n• 残額は均等に返金または継続使用\n• 適している：会社チームビルディング、旅行グループ',
        actualExpenseMode: '実費 + 均等分割：\n• メンバーが個別に支払い、レシートをアップロード\n• 総費用を全員で均等に分配\n• 最終的に差額を統一清算\n• 適している：臨時の活動、同僚の集まり',
      },
    },
    // 現在の設定プレビュー
    currentSettings: {
      title: '📋 現在の設定',
      expenseMode: '共有モード',
      shareMode: 'シェア分割',
      currency: '通貨',
      prepaidMode: '事前払いモード',
      actualExpenseMode: '実費モード',
      enabled: '有効',
      averageMode: '均等分割',
    },
  },

  // 費用統計
  statistics: {
    title: '旅行統計',
    loading: '統計を計算中...',
    // 概要統計
    summary: {
      totalSpent: '総支出',
      approvedAmount: '承認済み金額',
      averageShare: '平均シェア',
      averageSpent: '平均支出',
      budgetUsage: '予算使用率',
      expenseRecords: '費用記録',
      approvedReceipts: '承認済みレシート',
      budgetProgress: '予算使用状況',
      pending: '保留中',
      rejected: '拒否済み',
      receipts: 'レシート',
      groupMode: 'グループモード：事前払い、均等分割、簡単管理',
    },
    // カテゴリー統計
    categories: {
      title: '費用カテゴリー',
      transport: '交通',
      accommodation: '宿泊',
      food: '飲食',
      activities: 'アクティビティ',
      shopping: 'ショッピング',
      documents: '書類',
      other: 'その他',
    },
    // メンバー統計
    members: {
      shareDetails: 'メンバーシェア詳細',
      spentStats: 'メンバー支出統計',
      participation: 'メンバー参加状況',
      shareAmount: 'シェア金額',
      difference: '差額',
      shouldReceive: '受取額',
      shouldPay: '支払額',
      remainingBalance: '残高',
      needPayment: '支払いが必要',
      balanced: '均衡',
      unknownUser: '不明なユーザー',
      totalSpent: '総支出',
      averagePerPerson: '1人当たり平均',
      spent: '支出',
      transactions: '取引',
    },
  },

  // ToDo追加モーダル
  addTodoModal: {
    // ヘッダー
    title: 'ToDo項目を追加',
    // カスタム追加
    customAdd: {
      title: 'カスタム追加',
      titleLabel: 'タイトル',
      titlePlaceholder: 'ToDo項目のタイトルを入力',
      descriptionLabel: '説明',
      descriptionPlaceholder: '詳細な説明を入力（任意）',
      priorityLabel: '優先度',
    },
    // 優先度
    priority: {
      high: '高',
      medium: '中',
      low: '低',
    },
  },

  // 友達招待画面
  inviteFriends: {
    header: {
      title: '友達を招待',
      subtitle: '"{{groupName}}" に友達を招待',
    },
    search: {
      placeholder: '友達を検索...',
    },
    sections: {
      available: '招待可能な友達',
      members: '既に参加中のメンバー',
      pending: '保留中の招待',
    },
    status: {
      joined: 'すでにプロジェクトに参加済み',
      invitationSent: '招待送信済み、返信待ち',
    },
    actions: {
      sendInvitations: '招待を送信',
      sending: '送信中...',
      continueInviting: 'さらに招待',
      goBack: '戻る',
    },
    loading: {
      text: '友達リストを読み込み中...',
    },
    empty: {
      noFriends: {
        title: '友達がいません',
        subtitle: 'まず友達を追加してください',
      },
      noResults: {
        title: '検索結果がありません',
        subtitle: '他のキーワードを試してください',
      },
    },
    selection: {
      count: '{{count}}人の友達を選択',
      sendCount: '招待を送信（{{count}}）',
    },
    alerts: {
      selectFriends: '招待する友達を選択してください',
      userInfoFailed: 'ユーザー情報の取得に失敗しました',
      invitationSuccess: '招待が正常に送信されました',
      invitationSuccessMessage: '{{names}} に招待を送信しました',
      loadFriendsFailed: '友達リストの読み込みに失敗しました',
      sendInvitationsFailed: '招待の送信に失敗しました',
      error: 'エラー',
      hint: 'ヒント',
      unknownError: '不明なエラー',
      unknownUser: '不明なユーザー',
    },
  },

  // 目的地データ
  destinations: {
    countries: {
      // アジア
      CN: 'China',
      HK: 'Hong Kong',
      MO: 'Macau',
      TW: 'Taiwan',
      JP: 'Japan',
      KR: 'South Korea',
      TH: 'Thailand',
      SG: 'Singapore',
      MY: 'Malaysia',
      VN: 'Vietnam',
      ID: 'Indonesia',
      IN: 'India',
      AE: 'United Arab Emirates',
      // ヨーロッパ
      GB: 'United Kingdom',
      FR: 'France',
      DE: 'Germany',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      CH: 'Switzerland',
      // 北アメリカ
      US: 'United States',
      CA: 'Canada',
      // オセアニア
      AU: 'Australia',
      NZ: 'New Zealand',
    },
    cities: {
      // 都市レベルの目的地
      HongKong: '香港',
      Macau: 'マカオ',
      Singapore: 'シンガポール',
      // 中国の都市
      Beijing: '北京',
      Shanghai: '上海',
      Guangzhou: '広州',
      Shenzhen: '深セン',
      Hangzhou: '杭州',
      Chengdu: '成都',
      // 台湾の都市
      Taipei: '台北',
      Kaohsiung: '高雄',
      Taichung: '台中',
      Tainan: '台南',
      // 日本の都市
      Tokyo: '東京',
      Osaka: '大阪',
      Kyoto: '京都',
      Nagoya: '名古屋',
      Fukuoka: '福岡',
      Sapporo: '札幌',
      // 韓国の都市
      Seoul: 'ソウル',
      Busan: '釜山',
      Daegu: '大邱',
      Incheon: '仁川',
      // タイの都市
      Bangkok: 'バンコク',
      ChiangMai: 'チェンマイ',
      Phuket: 'プーケット',
      Pattaya: 'パタヤ',
      // マレーシアの都市
      KualaLumpur: 'クアラルンプール',
      Penang: 'ペナン',
      Malacca: 'マラッカ',
      JohorBahru: 'ジョホールバル',
      // ベトナムの都市
      HoChiMinhCity: 'ホーチミン',
      Hanoi: 'ハノイ',
      DaNang: 'ダナン',
      NhaTrang: 'ニャチャン',
      // インドネシアの都市
      Jakarta: 'ジャカルタ',
      Bali: 'バリ',
      Yogyakarta: 'ジョグジャカルタ',
      Surabaya: 'スラバヤ',
      // インドの都市
      NewDelhi: 'ニューデリー',
      Mumbai: 'ムンバイ',
      Bangalore: 'バンガロール',
      Kolkata: 'コルカタ',
      // アラブ首長国連邦の都市
      Dubai: 'ドバイ',
      AbuDhabi: 'アブダビ',
      // イギリスの都市
      London: 'ロンドン',
      Edinburgh: 'エディンバラ',
      Manchester: 'マンチェスター',
      Liverpool: 'リバプール',
      // フランスの都市
      Paris: 'パリ',
      Lyon: 'リヨン',
      Marseille: 'マルセイユ',
      Nice: 'ニース',
      // ドイツの都市
      Berlin: 'ベルリン',
      Munich: 'ミュンヘン',
      Hamburg: 'ハンブルク',
      Frankfurt: 'フランクフルト',
      // イタリアの都市
      Rome: 'ローマ',
      Milan: 'ミラノ',
      Venice: 'ベネチア',
      Florence: 'フィレンツェ',
      // スペインの都市
      Madrid: 'マドリード',
      Barcelona: 'バルセロナ',
      Valencia: 'バレンシア',
      Seville: 'セビリア',
      // オランダの都市
      Amsterdam: 'アムステルダム',
      Rotterdam: 'ロッテルダム',
      TheHague: 'ハーグ',
      // スイスの都市
      Zurich: 'チューリッヒ',
      Geneva: 'ジュネーブ',
      Basel: 'バーゼル',
      // アメリカの都市
      NewYork: 'ニューヨーク',
      LosAngeles: 'ロサンゼルス',
      Chicago: 'シカゴ',
      SanFrancisco: 'サンフランシスコ',
      LasVegas: 'ラスベガス',
      Miami: 'マイアミ',
      // カナダの都市
      Toronto: 'トロント',
      Vancouver: 'バンクーバー',
      Montreal: 'モントリオール',
      Ottawa: 'オタワ',
      // オーストラリアの都市
      Sydney: 'シドニー',
      Melbourne: 'メルボルン',
      Brisbane: 'ブリスベン',
      Perth: 'パース',
      // ニュージーランドの都市
      Auckland: 'オークランド',
      Wellington: 'ウェリントン',
      Christchurch: 'クライストチャーチ',
    },
  },

  // 旅行チャット
  travelChat: {
    header: {
      title: '{{groupName}} チャットルーム',
      subtitle: '旅行グループチャット',
    },
    loading: {
      text: 'チャット履歴を読み込み中...',
    },
    empty: {
      title: 'まだチャット履歴がありません',
      subtitle: 'チームメイトとチャットを始めましょう！',
    },
    input: {
      placeholder: 'メッセージを入力...',
    },
    time: {
      today: '今日',
      yesterday: '昨日',
    },
    errors: {
      sendFailed: '送信に失敗しました',
      networkError: 'ネットワークエラー、もう一度お試しください',
    },
    user: {
      unknown: '不明なユーザー',
    },
  },

  // 費用管理
  expenseManagement: {
    
  fullAmount: '金額の詳細',
    ledgerTabs: {
      public: 'グループ台帳',
      private: 'メンバー個別台帳',
    },
  // 統計
    statistics: {
      title: '費用統計',
      settings: '設定',
      consumed: '消費済み',
      totalExpense: '総費用',
      approvedReceipts: '承認済みレシート',
      pendingReview: 'レビュー待ち',
      averagePerPerson: '1人当たり平均',
      averagePerShare: 'シェア当たり平均',
      categoryStatistics: '費用カテゴリー統計',
      shareMode: 'シェア分割',
      averageMode: '均等分割',
      perSharePayable: 'シェア当たり支払額',
  averageSplit: '均等分割',
    },
    // レシート
    receipts: {
      title: 'レシート',
      upload: 'アップロード',
      exportPDF: 'PDF',
      exporting: '出力中...',
      approve: '承認',
      reject: '拒否',
      confirmTitle: '操作の確認',
      confirmApprove: 'このレシートを承認しますか？',
      confirmReject: 'このレシートを拒否しますか？',
      cancel: 'キャンセル',
      confirm: '確認',
      approved: 'レシートが承認されました',
      rejected: 'レシートが拒否されました',
      success: '操作が成功しました',
      error: '操作に失敗しました',
      approveFailed: '承認に失敗しました',
      rejectFailed: '拒否に失敗しました',
      operationFailed: '操作に失敗しました',
      imageUnavailable: '画像が利用できません',
      imageLoadError: '画像の読み込みに失敗しました',
      cannotDisplay: '画像を表示できません',
      emptyTitle: 'レシートがありません',
      emptySubtitle: '上の「アップロード」ボタンをクリックしてレシートを追加してください',
    },
    privateReceipts: {
      modeInfo: 'ここはメンバーの個人用記録であり、個人の精算にのみ影響します。',
      loading: '個別台帳を読み込み中…',
      loadFailed: '個別台帳の読み込みに失敗しました',
      loadFailedHint: 'ネットワーク接続を確認して、もう一度お試しください。',
      retry: '再試行',
      emptyTitle: '個別台帳はまだありません',
      emptySubtitle: 'メンバーが自分の個人支出をアップロードするか、上の「アップロード」ボタンから最初の記録を追加できます。',
      settlementTitle: 'メンバー間の清算',
      settlementAmount: '{{payer}} が {{receiver}} に {{amount}} を支払う',
      settlementYouOwe: 'あなたは {{receiver}} に {{amount}} を支払う必要があります',
      settlementOwesYou: '{{payer}} があなたに {{amount}} を支払う必要があります',
      settlementEmpty: '現在、清算が必要なメンバー間の残高はありません。',
      noPersonalSettlements: 'あなたに関係する個別清算はありません。',
      noPersonalReceipts: 'あなたに関連する個別台帳はありません。',
      noPersonalReceiptsSubtitle: '他のメンバー間の個別台帳はここには表示されません。',
      youLabel: 'あなた',
      vsSeparator: ' vs ',
    },
    // 状態
    status: {
      pending: '保留中',
      approved: '承認済み',
      rejected: '拒否済み',
    },
    // 拒否理由
    rejectionReason: {
      title: '拒否理由',
    },
    // 拒否入力
    rejectInput: {
      title: 'レシート拒否',
      label: '拒否理由を入力してください：',
      placeholder: 'このレシートを拒否する詳細な理由を入力してください...',
      cancel: 'キャンセル',
      confirm: '拒否確認',
    },
    // メンバー残高
    memberBalance: {
      title: 'メンバー残高',
      paid: '支払済み',
      shouldPay: '支払うべき金額',
      overpaid: '過払い',
      owes: '未払い',
      share: 'シェア',
    },
    // 支払いモード
    paymentMode: {
      prepaid: '事前払いモード',
      actualExpense: '実費',
      shareMode: 'シェアモード',
      equalMode: '均等モード',
    },
    // カテゴリー統計
    categoryStats: {
      title: 'カテゴリー統計',
      total: '合計',
    },
    // カテゴリー
    categories: {
      transport: '交通',
      accommodation: '宿泊',
      food: '飲食',
      flight: 'フライト',
      taxi: 'タクシー',
      attractions: '観光地',
      shopping: 'ショッピング',
      entertainment: 'エンターテインメント',
      insurance: '保険',
      visa: 'ビザ',
      communication: '通信',
      general: 'その他',
    },
    // エクスポート
    export: {
      error: 'エクスポートに失敗しました',
      noData: 'エクスポートするデータがありません',
      success: 'エクスポート成功',
      successMessage: 'PDFレポートが生成され、共有準備が整いました',
      failed: 'エクスポートに失敗しました、もう一度お試しください',
    },
    // PDFレポート翻訳
    pdfReport: {
      title: '費用レポート',
      subtitle: '財務詳細と統計分析',
      generatedBy: 'PDF生成者',
      brandName: 'Cube Meet',
      brandWebsite: 'https://cubemeet.app',
      generatedAt: '生成日時',
      brandFooter: 'Cube Meet - スマートな財務管理プラットフォームによる提供',
      brandSlogan: 'スマートな生活、費用追跡から始まる',
      // セクションタイトル
      sections: {
        overview: '財務概要',
        memberBalances: 'メンバー残高詳細',
        expenseDetails: '費用詳細',
        receipts: '費用レシート詳細',
        categoryStats: '費用カテゴリー統計',
        categoryBreakdown: 'カテゴリー内訳',
      },
      // 概要項目
      overview: {
        totalExpense: '総費用',
        memberCount: 'メンバー数',
        approvedReceipts: '承認済みレシート',
        pendingReceipts: '保留中のレシート',
        memberUnit: 'メンバー',
        receiptUnit: 'レシート',
      },
      // テーブルヘッダー
      tableHeaders: {
        member: 'メンバー',
        spent: '支出',
        shouldPay: '支払うべき金額',
        balance: '残高',
        share: 'シェア',
        title: 'タイトル',
        amount: '金額',
        category: 'カテゴリー',
        date: '日付',
        uploader: 'アップローダー',
        status: '状態',
        percentage: '割合',
        unknown: '不明',
      },
      // 状態翻訳
      status: {
        approved: '承認済み',
        rejected: '拒否済み',
        pending: '保留中',
        unknown: '不明',
      },
      // 残高状態
      balanceStatus: {
        overpaid: '過払い',
        owed: '未払い',
      },
    },
  },

  // ホーム
  home: {
    welcomeBack: 'お帰りなさい',
    discoverTravel: '旅行を探す',
    discoverPlans: '素晴らしい旅行プランを見つけよう',
    whereToGo: 'どこへ行きますか？',
    viewMore: 'もっと見る',
    recommendedCards: 'おすすめカード',
    latestPosts: '最新の旅行記',
    loginPrompt: 'ログインして旅程を作成・管理',
    loginButton: 'ログイン / 登録',
  },

  // カードリスト
  cardList: {
    title: 'カード一覧',
    searchPlaceholder: 'カードを検索...',
    types: {
      poi: '観光スポット',
      restaurant: 'レストラン',
      lodging: '宿泊',
      activity: 'アクティビティ',
      shopping: 'ショッピング',
    },
    filters: {
      tags: 'タグ',
      category: 'カテゴリ',
      subcategory: 'サブカテゴリ',
      location: '地域',
      clear: 'クリア',
    },
    status: {
      loading: '読み込み中...',
      switchingPages: 'ページ切り替え中...',
      noMore: 'これ以上カードはありません',
      emptyTitle: 'カードが見つかりません',
      emptyText: '検索条件やフィルターを調整してください',
    },
    modal: {
      title: 'カード詳細',
      close: '閉じる',
      addToItinerary: '旅程に追加',
    }
  },

  // カード詳細ページ
  cardDetail: {
    tabs: {
      book: '予約',
      details: '詳細',
      nearby: '周辺',
      description: '説明',
    },
    gallery: {
      allPhotos: 'すべての写真',
      tripPhotos: '旅行の写真',
      addPhoto: '写真を追加',
    },
    affiliate: {
      bookOn: '{{brand}}で予約',
      searchOn: '{{brand}}で検索',
    },
  },

  // 旅行投稿詳細
  travelPostDetail: {
    loading: '読み込み中...',
    emptyContent: 'コンテンツはまだありません',
    meta: {
      defaultTitle: '旅行ノート',
      siteName: 'Cubemeet',
    },
    breadcrumbs: {
      home: 'ホーム',
      city: '都市',
      guide: 'ガイド',
    },
    messages: {
      cloneSuccess: '旅程がコピーされました。リダイレクト中...',
      cloneFailed: '旅程のコピーに失敗しました。後でもう一度お試しください',
      postNotFound: '投稿が見つからないか、削除されました',
      loadFailed: '投稿の読み込みに失敗しました',
      followFailed: 'フォローに失敗しました',
      followed: 'フォローしました',
      noMapData: '地図データがありません',
    },
    actions: {
      retry: '再試行',
      back: '戻る',
      backToTop: 'トップに戻る',
      cloneToItinerary: '旅程にコピー',
      viewMap: '地図表示',
    },
    error: {
      notFound: '投稿が見つかりません',
    },
    cloneModal: {
      title: '旅程にコピー',
      labelTitle: '旅程タイトル',
      placeholderTitle: '旅程タイトルを入力',
      labelStartDate: '開始日',
      cancel: 'キャンセル',
      confirm: 'コピーを確認',
      copyOf: 'Copy of',
    },
    postEngagement: {
      auth: {
        authenticated: '認証済み',
        unauthenticated: '未認証',
        pleaseLogin: 'コメントするにはログインしてください',
        checkFailed: '認証チェックに失敗しました',
      },
      comment: {
        anonymous: '匿名ユーザー',
        empty: 'コメントが空です',
        start: 'コメントを投稿中...',
        success: 'コメントを投稿しました',
        reload: 'コメントを再読み込み中...',
        failed: 'コメントの投稿に失敗しました',
        unknownError: '不明なエラー',
        placeholder: '何かコメント...',
        sending: '送信中...',
        send: '送信',
        total: '{{count}} 件のコメント',
        loading: 'コメントを読み込み中...',
        loadMore: 'さらにコメントを読み込む',
        avatarError: 'アバターの読み込みに失敗しました',
      },
      time: {
        justNow: 'たった今',
        minsAgo: '{{count}}分前',
        hoursAgo: '{{count}}時間前',
        daysAgo: '{{count}}日前',
      },
      badge: {
        author: '著者',
        admin: '管理者',
        agency: '認証済み',
      },
      richContent: {
        imageLoadFailed: '画像の読み込みに失敗しました:',
        imageAlt: '画像',
        empty: 'コンテンツがありません',
      },
    },
  },

  snapshot: {
      noContent: 'コンテンツがありません',
      imageLoadFailed: '画像の読み込みに失敗しました',
      day: '{{number}}日目',
      openCardDetails: 'カードの詳細を開く',
      openCardInNewWindow: '新しいウィンドウでカードを開く',
      prevImage: '前の画像',
      nextImage: '次の画像',
    },
};